var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 8V11.8C8.8 12.3523 9.24772 12.8 9.8 12.8H11C11.5523 12.8 12 12.3523 12 11.8V11.4C12 10.8477 12.4477 10.4 13 10.4H17.6M8.8 8L5.89289 10.9071C5.70536 11.0946 5.6 11.349 5.6 11.6142V14.0118C5.6 14.2604 5.50125 14.4987 5.32548 14.6745V14.6745C4.59344 15.4066 4.59344 16.5934 5.32548 17.3255L6.58579 18.5858C7.36684 19.3668 8.63317 19.3668 9.41421 18.5858L10.9071 17.0929C11.0946 16.9054 11.349 16.8 11.6142 16.8H14.9333C15.5224 16.8 16 16.3224 16 15.7333V15.7333C16 15.4388 16.2388 15.2 16.5333 15.2V15.2C17.1224 15.2 17.6 14.7224 17.6 14.1333V14.1333C17.6 13.8388 17.8388 13.6 18.1333 13.6V13.6C18.7224 13.6 19.2 13.1224 19.2 12.5333V11.4C19.2 10.8477 18.7523 10.4 18.2 10.4H17.6M8.8 8V8C8.8 7.11634 9.51634 6.4 10.4 6.4H13.1858C13.451 6.4 13.7054 6.29464 13.8929 6.10711L14.5858 5.41421C15.3668 4.63317 16.6332 4.63317 17.4142 5.41421L18.5858 6.58579C19.3668 7.36684 19.3668 8.63317 18.5858 9.41421L17.6 10.4",
    stroke: "#9DA1B5",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDeal);
export default __webpack_public_path__ + "static/media/menuDeal.23181a8ebcb2ae2ef07719c9a3700be5.svg";
export { ForwardRef as ReactComponent };